import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import ChooseSourceTypeModal from '../components/App/ChooseSource';

function ChooseSourceRoute({ basePath }) {
  const [openChooseModal, setOpenChooseModal] = useState(false);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (
      location.pathname === '/inventory/instance-wizard/choose-source'
    ) {
      setOpenChooseModal(true);
    }
    return () => {
      setOpenChooseModal(false);
    };
  }, [location, location.pathname]);

  return (
    <ChooseSourceTypeModal
      basePath={basePath}
      open={openChooseModal}
      onClose={() => {
        setOpenChooseModal(!openChooseModal);
        history.go(-1);
      }}
    />
  );
}

ChooseSourceRoute.propTypes = {
  basePath: PropTypes.string.isRequired,
};

export default ChooseSourceRoute;
